import React, { createContext, useContext, useState } from 'react';

const PageMetadataContext = createContext();
const usePageMetadata = () => useContext(PageMetadataContext);

const PageMetadataProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [showTitleInHeader, setShowTitleInHeader] = useState(true);
  const [headerAction, setHeaderAction] = useState(null);

  return (
    <PageMetadataContext.Provider value={{ title, setTitle, showTitleInHeader, setShowTitleInHeader, headerAction, setHeaderAction }}>
      {children}
    </PageMetadataContext.Provider>
  );
};

export { PageMetadataProvider, usePageMetadata };